import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ReloadKey {
  clinicalAlertReloadKey : number ;
}

const initialState:ReloadKey = {
    clinicalAlertReloadKey : 0
};

const clinicalAlertReloadSlice = createSlice({
  name: "clinicalAlertReloadKey",
  initialState,
  reducers: {
    setClinicalAlertReloadKey(state, action: PayloadAction<number>) {state.clinicalAlertReloadKey=action.payload},
    clearClinicalAlertReloadKey(state) {
      state.clinicalAlertReloadKey = 0;
    },
  },
});


export const { setClinicalAlertReloadKey, clearClinicalAlertReloadKey } = clinicalAlertReloadSlice.actions;

export default clinicalAlertReloadSlice.reducer;
